module.exports = __webpack_public_path__ + "static/assets/6cfc8644715e45f1dd5ac7498d133948.png";